import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import useEnvInfo from '@core/hooks/useEnvInfo';

/**
 * Helper function to get the markdown version of the current URL.
 */
export function useMarkdownUrl() {
  const { isServer } = useEnvInfo();
  const location = useLocation();

  if (isServer) return '';

  const currentPath = location.pathname;

  // Handle different URL patterns more robustly
  let mdPath = '';
  if (currentPath.endsWith('/')) {
    mdPath = `${currentPath}index.md`;
  } else if (currentPath.includes('.')) {
    // Replace existing extension with .md
    mdPath = currentPath.replace(/\.[^/.]+$/, '.md');
  } else {
    // No extension and not trailing slash, just append .md
    mdPath = `${currentPath}.md`;
  }

  return `${window.location.origin}${mdPath}`;
}

/**
 * Returns a function that generates a prompt for a given AI agent bot with the
 * current markdown URL as context.
 */
export function useMarkdownUrlPrompt() {
  const markdownUrl = useMarkdownUrl();

  return useCallback(
    (bot: 'ChatGPT' | 'Claude' | 'Copilot') => {
      return encodeURIComponent(
        `Hi ${bot}! Can you please read [this page](${markdownUrl}) and prepare to answer questions about it?`,
      );
    },
    [markdownUrl],
  );
}
